/**
 * Cálculos de datas da gestação.
 * Datas "de calendário" (sem hora) são tratadas como texto AAAA-MM-DD, para não
 * sofrer com fuso horário (um dia a menos às 21h, por exemplo).
 */

const MS_POR_DIA = 24 * 60 * 60 * 1000;

function paraDiaUtc(dataIso: string): number {
  const partes = /^(\d{4})-(\d{2})-(\d{2})$/.exec(dataIso);
  if (!partes) throw new Error(`Data inválida (use AAAA-MM-DD): ${dataIso}`);
  const [, ano, mes, dia] = partes;
  const ms = Date.UTC(Number(ano), Number(mes) - 1, Number(dia));
  const conferencia = new Date(ms);
  if (conferencia.getUTCDate() !== Number(dia)) throw new Error(`Data inexistente: ${dataIso}`);
  return ms;
}

function paraIso(ms: number): string {
  return new Date(ms).toISOString().slice(0, 10);
}

/** Diferença em dias entre duas datas AAAA-MM-DD (fim − início). */
export function diasEntre(inicio: string, fim: string): number {
  return Math.round((paraDiaUtc(fim) - paraDiaUtc(inicio)) / MS_POR_DIA);
}

/** Soma dias a uma data AAAA-MM-DD. */
export function somarDias(data: string, dias: number): string {
  return paraIso(paraDiaUtc(data) + dias * MS_POR_DIA);
}

/** Data provável do parto pela regra de Naegele: DUM + 280 dias. */
export function dataProvavelParto(dum: string): string {
  return somarDias(dum, 280);
}

/** Idade gestacional na data de referência, a partir da DUM. */
export function idadeGestacional(
  dum: string,
  referencia: string,
): { semanas: number; dias: number } {
  const total = diasEntre(dum, referencia);
  if (total < 0) throw new Error('A data de referência é anterior à DUM.');
  return { semanas: Math.floor(total / 7), dias: total % 7 };
}

/** "2026-06-18" → "18/06/2026". */
export function formatarDataBR(dataIso: string): string {
  const [ano, mes, dia] = dataIso.slice(0, 10).split('-');
  return `${dia}/${mes}/${ano}`;
}
